import React from 'react';
import { Button, message } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import * as ExcelJS from 'exceljs';

const ExportExcelButton = ({ novedades, fileName = 'novedades_participantes' }) => {
  const exportToExcel = async () => {
    try {
      // Crear workbook y worksheet
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Novedades');

      // Definir columnas
      worksheet.columns = [
        { header: '#', key: 'contador', width: 8 },
        { header: 'Departamento', key: 'departamento', width: 20 },
        { header: 'Municipio', key: 'municipio', width: 20 },
        { header: 'Participante', key: 'nombre_participante', width: 30 },
        { header: 'Cédula', key: 'numero_identificacion', width: 15 },
        { header: 'Tipo Novedad', key: 'tipo_novedad', width: 25 },
        { header: 'Estado', key: 'estado', width: 15 },
        { header: 'Reemplazado', key: 'estado_remplazo', width: 15 },
        { header: 'Participante Reemplazo', key: 'nombre_reemplazo', width: 30 },
        { header: 'Cédula Reemplazo', key: 'identificacion_reemplazo', width: 15 },
        { header: 'Fecha Registro', key: 'fecha_registro', width: 15 },
        { header: 'Observación', key: 'observacion', width: 40 },
      ];

      // Estilo para el header
      worksheet.getRow(1).eachCell((cell) => {
        cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FF4F81BD' }
        };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
      });

      // Mapear los datos con contador
      const rows = novedades.map((novedad, index) => ({
        contador: index + 1, // Contador secuencial
        departamento: novedad.departamento || '',
        municipio: novedad.municipio || '',
        nombre_participante: novedad.nombre_participante || '',
        numero_identificacion: novedad.numero_identificacion || '',
        tipo_novedad: getTipoNovedadText(novedad.tipo_novedad),
        estado: getEstadoText(novedad.estado),
        estado_remplazo: getReemplazoText(novedad.estado_remplazo),
        nombre_reemplazo: novedad.nombre_reemplazo || 'No aplica',
        identificacion_reemplazo: novedad.identificacion_reemplazo || 'No aplica',
        fecha_registro: novedad.fecha_registro || '',
        observacion: novedad.observacion || '',
      }));

      // Agregar filas
      worksheet.addRows(rows);

      // Aplicar estilos a las filas de datos
      worksheet.eachRow((row, rowNumber) => {
        if (rowNumber > 1) {
          row.eachCell((cell, colNumber) => {
            cell.border = {
              top: { style: 'thin' },
              left: { style: 'thin' },
              bottom: { style: 'thin' },
              right: { style: 'thin' }
            };
            
            // Alineación centrada para columnas específicas
            if (colNumber === 1) { // Columna # (contador)
              cell.alignment = { vertical: 'middle', horizontal: 'center' };
            } 
            else if (colNumber === 9 || colNumber === 10) { // Estado (col 9) y Reemplazado (col 10)
              cell.alignment = { vertical: 'middle', horizontal: 'center' };
            }
            else {
              cell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
            }
          });
        }
      });

      // Autoajustar altura de filas para observación
      worksheet.getColumn('observacion').eachCell((cell) => {
        cell.alignment = { wrapText: true };
      });


      // Generar archivo
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      
      // Descargar
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${fileName}_${new Date().toISOString().split('T')[0]}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      message.success(`Archivo Excel generado exitosamente con ${novedades.length} registros`);

    } catch (error) {
      console.error('Error al exportar a Excel:', error);
      message.error('Error al generar el archivo Excel');
    }
  };

  // Función para obtener el texto del tipo de novedad
  const getTipoNovedadText = (tipo) => {
    const tipos = {
      '1': 'Fallecimiento',
      '2': 'Retiro Voluntario',
      '3': 'Exclusión',
      '4': 'Corrección o actualización de información',
      '5': 'Otra'
    };
    return tipos[tipo] || tipo;
  };

  // Función para obtener el texto del estado
  const getEstadoText = (estado) => {
    const estados = {
      '1': 'Activo',
      '2': 'Inactivo'
    };
    return estados[estado] || estado;
  };

  // Función para obtener el texto de reemplazo
  const getReemplazoText = (reemplazo) => {
    const reemplazos = {
      '0': 'No',
      '1': 'Sí'
    };
    return reemplazos[reemplazo] || reemplazo;
  };

  return (
    <Button 
      type="primary" 
      icon={<DownloadOutlined />}
      onClick={exportToExcel}
      style={{ marginLeft: 8 }}
      disabled={!novedades || novedades.length === 0}
    >
      Exportar Excel
    </Button>
  );
};

export default ExportExcelButton;